import { MarketData, Watchlist } from "@bloomberg/octagon-client";
import { getCookie, setCookie } from "cookies-next";

const SERVICE_URL = `${
  process.env.NEXT_PUBLIC_REGISTRATION_URL || "https://login.bloomberg.com"
}/octagon/api/`;

const APP_ID = process.env.NEXT_PUBLIC_OCTAGON_APP_ID || "";
const JWT_TOKEN_KEY = "octagon-jwtToken";

let watchlist: Watchlist | undefined;
let marketData: MarketData | undefined;

const getTokenFromStorage = async (): Promise<string | undefined> => {
  const token = await getCookie(JWT_TOKEN_KEY);

  return typeof token === "string" ? token : undefined;
};

const setTokenToStorage = async (token: string | undefined): Promise<void> => {
  if (!token) return;
  await setCookie(JWT_TOKEN_KEY, token, {
    maxAge: 300,
    secure: true,
    sameSite: "strict",
  });
};

export const watchlistClient = {
  getInstance(): Watchlist {
    if (watchlist) return watchlist;

    watchlist = new Watchlist({
      appId: APP_ID,
      getJWTTokenHandler: getTokenFromStorage,
      setJWTTokenHandler: setTokenToStorage,
      serviceUrl: SERVICE_URL,
    });

    return watchlist;
  },

  resetInstance(): void {
    watchlist = undefined;
  },
};

export const marketDataClient = {
  getInstance(): MarketData {
    if (marketData) return marketData;

    marketData = new MarketData({
      appId: APP_ID,
      getJWTTokenHandler: getTokenFromStorage,
      setJWTTokenHandler: setTokenToStorage,
      serviceUrl: SERVICE_URL,
    });

    return marketData;
  },

  resetInstance(): void {
    marketData = undefined;
  },
};
